import Cookie from 'js-cookie';
import 'slick-carousel/slick/slick.js';
import 'lightslider/dist/js/lightslider.js';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import fullScreen from 'lightgallery/plugins/fullscreen';

function initPropertyImageGallery() {
  const $g = jQuery('#propertyImageGallery');
  if (!$g.length || typeof jQuery.fn.lightSlider !== 'function') {
    return;
  }
  if ($g.data('lightSlider')) {
    return;
  }

  const slideCount = $g.children('li').length;
  const thumbCount = (maxVisible) => Math.min(maxVisible, Math.max(1, slideCount));
  $g.removeClass('cs-hidden');

  $g.lightSlider({
    gallery: true,
    item: 1,
    loop: slideCount > 1,
    thumbItem: thumbCount(9),
    slideMargin: 0,
    enableDrag: false,
    currentPagerPosition: 'left',
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          thumbItem: thumbCount(4),
        },
      },
    ],
    onSliderLoad() {
      const el = document.getElementById('propertyImageGallery');
      if (!el) {
        return;
      }
      lightGallery(el, {
        selector: 'li .property-gallery__link',
        plugins: [lgThumbnail, lgZoom, fullScreen],
        download: false,
        speed: 400,
      });
    },
  });
}

export default {
 init() {
   // Initialization code for all pages (if needed)
 },
 
 finalize() {
   // Finalization code for all pages, after page-specific JS is fired
   
   if ($('.testimonials-carousel').length) {
    const $carousel = $('.testimonials-carousel');

    // Initialize Slick
    $carousel.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: '.testimonials-panel .slider-nav',
      appendDots: '.testimonials-panel .slider-nav',
      adaptiveHeight: false,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
          },
        },
      ],
    });
  }
  
  if ($('.section-image-carousel').length) {
    $('.section-image-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.section-listings-carousel',
    });
  }

  if ($('.section-listings-carousel').length) {
    $('.section-listings-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: '.section-listings .slider-nav',
      appendDots: '.section-listings .slider-nav',
      adaptiveHeight: true,
      arrows: false,
      dots: true,
      infinite: true,
      asNavFor: '.section-image-carousel',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: false,
            arrows: true,
          },
        },
      ],
    });
  }

  // Shortens long text and adds read more / less links
  function addReadMoreLink(className, maxLength, sliderSelector = '.testimonials-carousel') {
    $('.' + className).each(function () {
      var text = $(this).text();

      if (text.length > maxLength) {
        var shortText = text.substr(0, maxLength);
        var longText = text.substr(maxLength);

        var html =
          shortText +
          '<a href="#" class="read-more">... More</a>' +
          '<span class="more-text">' + longText + '</span>' +
          '<a href="#" class="read-less"> Less</a>';

        $(this).html(html);

        $(this).find('.more-text').hide();
        $(this).find('.read-less').hide();
      }
    });

    // Read more
    $(document).on('click', '.' + className + ' .read-more', function (e) {
      e.preventDefault();

      const $slider = $(sliderSelector);

      $(this).hide();
      $(this).siblings('.more-text').show();
      $(this).siblings('.read-less').show();

      // 🔥 Force Slick to recalc adaptive height
      if ($slider.length && $slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    });

    // Read less
    $(document).on('click', '.' + className + ' .read-less', function (e) {
      e.preventDefault();

      const $slider = $(sliderSelector);

      $(this).hide();
      $(this).siblings('.more-text').hide();
      $(this).siblings('.read-more').show();

      // 🔥 Force Slick to recalc adaptive height
      if ($slider.length && $slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    });
  }

  //function call back (text class name, text max length)
  addReadMoreLink('testimonial', 492);

   // Hamburger toggle functionality
    let removeClass = true;
    $('.hamburger').click(() => {
      $('.hamburger').toggleClass('is-active');
      $('#sideNav').toggleClass('sideNav-open');
      $('.sideNavBody').toggleClass('sideNavBody-push');
      removeClass = false;
    });

    $('.sideNav').click(() => {
      removeClass = false;
    });

    // Close hamburger menu on touch outside
    $(document).on('click touchstart', (e) => {
       if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
         $('.hamburger').removeClass('is-active');
         $('#sideNav').removeClass('sideNav-open');
         $('.sideNavBody').removeClass('sideNavBody-push');
       }
       removeClass = true;
     });

   // Show/hide scroll-to-top button based on scroll position
   $(window).scroll(function() {
     $('.scrollup').toggle($(this).scrollTop() > 100);
   });

   // Scroll-to-top functionality
   $('.scrollup').click(function() {
     $('html, body').animate({
       scrollTop: 0,
     }, 600);
     return false;
   });

   // Dropdown and mobile menu functionality

   // Dropdown on click (top nav + primary nav: only one open at a time)
   $('.banner ul > li.menu-item-has-children > a').click(function (e) {
     e.preventDefault();
     const $parent = $(this).parent('.banner ul > li.menu-item-has-children');
     $('.banner li.menu-item-has-children.open').not($parent).removeClass('open');
     $parent.toggleClass('open');
   });

   // Close dropdown when clicking anywhere else
   $(document).on('click touch', (e) => {
     if (!$(e.target).hasClass('menu-item-has-children') && !$(e.target).parents('.banner ul li.menu-item-has-children').length) {
       $('.banner ul li.menu-item-has-children.open').removeClass('open');
     }
   });

   // SideNav dropdown on click
   $('.sideNav li.menu-item-has-children > a').click(function (e) {
     e.preventDefault();
     $(this).next('.sideNav .sub-menu').slideToggle();
     $(this).parent('.sideNav li.menu-item-has-children').toggleClass('open');
   });

   // Close SideNav dropdown on link click
   $('.sideNav .sub-menu li:not(.menu-item-has-children) a').click(() => {
     $('.hamburger').removeClass('is-active');
     $('#sideNav').removeClass('sideNav-open');
     $('.sideNavBody').removeClass('sideNavBody-push');
   });

   //open external links in new tab
   $('a[href^="http"]').each(function() {
     if (this.hostname !== window.location.hostname) {
       $(this).attr('target', '_blank');
     }
   });

   // Add icons to text links that open in a new tab
   $(document).ready(function() {
     const $links = $('a[target="_blank"]').filter(function() {
       return $(this).text().trim().length > 0 && $(this).find('i').length === 0;
     });

     $links.each(function() {
       const href = $(this).attr('href');
       if (href && href.trim().length !== 0 && !href.startsWith('mailto:')) {
         const iconClass = href.endsWith('.pdf') ? 'fa-solid fa-file-pdf' : 'fa-solid fa-square-arrow-up-right';
         $(this).append(` <i class="mx-1 ${iconClass}"></i>`);
       }
     });
   });

   // Alert popup functionality

   if (!Cookie.get('alert') && $('#modal').length || $('#modal').hasClass('no-cookie')) {
     $('#modal').show();
     Cookie.remove('alert');
   }

   $('.modal .btn-close').click(function() {
     $('#modal').hide();
     Cookie.set('alert', true, {
       expires: 1,
     });
   });

 //review us page
 $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
   localStorage.setItem('activeTab', $(e.target).attr('href'));
 });
 // Get the stored active tab from localStorage
 var activeTab = localStorage.getItem('activeTab');
 // If there is no stored active tab or it doesn't exist, set the first tab as active
 if (!activeTab || !$('#review-tab a[href="' + activeTab + '"]').length) {
   $('#review-tab a[data-toggle="tab"]').first().tab('show');
 } else {
   // If there is a stored active tab, show it
   $('#review-tab a[href="' + activeTab + '"]').tab('show');
 }

   initPropertyImageGallery();

 },
};
